import { useState } from "react";
import Button from "../Button/Button";
import Modal from "../Modal/Modal";
import { ensureCurrentUser } from "../../util/data";
import { useSelector } from "react-redux";
import css from "./SMSVerification.module.css";

function SMSVerification() {
  const [openModel, setOpenModel] = useState(false);
  const [invalidNumber, setInvalidNumber] = useState(false);
  const [verificationCode, setVerificationCode] = useState(null);
  const [reSend, setReSend] = useState(false);
  const user = ensureCurrentUser(useSelector((state) => state.user));

  const userPhoneNumber =
    user.currentUser.attributes.profile.protectedData.phoneNumber;
  const handleModalOpen = () => {
    if (!userPhoneNumber) {
      setInvalidNumber(true);
      return;
    }

    setInvalidNumber(false);

    // Send SMS verification code
    fetch(
      `${process.env.REACT_APP_INSTAGROOMS_CORE_URL}/send-sms-verification-code`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({ phoneNumber: userPhoneNumber }),
      }
    ).then((response) => {
      if (response.ok) {
        console.log("SMS verification code sent successfully");
      } else {
        console.error("Failed to send SMS verification code");
      }
    });

    setOpenModel(true);
    return;
  };

  const handleModalClose = () => {
    setOpenModel(false);
    return;
  };

  const handleResendVerification = () => {
    handleModalOpen();
    setReSend(true);
  };

  const handleVerification = () => {
    fetch(`${process.env.REACT_APP_INSTAGROOMS_CORE_URL}/validate-code`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        code: verificationCode,
        userId: user.currentUser.id.uuid,
      }),
      credentials: "include",
    }).then(async (response) => {
      if (response.ok) {
        console.log("Verification Code Accepted");

        // reload page
        window.location.reload();
      } else {
        console.error("Verification Code Rejected");
        const data = await response.json();
        console.error(data);
      }
    });
  };

  return (
    <div>
      <Button type="button" onClick={handleModalOpen}>
        Verify Phone Number
      </Button>
      {invalidNumber && (
        <p style={{ color: "red" }}>
          You need to add and save a phone number to your account before you can
          verify it.
        </p>
      )}

      <Modal
        onManageDisableScrolling={() =>
          console.log("Toggling Modal - scrollingDisabled currently:")
        }
        className={css.verificationModal}
        isOpen={openModel}
        onClose={handleModalClose}
        id="verification-modal"
      >
        <h2>Verify Phone Number</h2>
        <p>
          We have sent a verification code to your phone number (
          {userPhoneNumber}). Please enter the code below.
        </p>

        <span>Didn't get the code? </span>
        <Button
          type="button"
          id={css.resendVerificationButton}
          onClick={handleResendVerification}
        >
          Resend Verification Code
        </Button>
        {reSend && <p>Verification code sent successfully</p>}
        <input
          name="verification-code"
          type="text"
          placeholder="Enter code"
          onChange={(e) => setVerificationCode(e.target.value)}
        />
        <Button
          onClick={handleVerification}
          className={css.verificationSubmitButton}
          type="button"
        >
          Verify
        </Button>
      </Modal>
    </div>
  );
}

export default SMSVerification;
